import { render, staticRenderFns } from "./UnbornReasons.vue?vue&type=template&id=26cc78bc"
import script from "./UnbornReasons.vue?vue&type=script&lang=js"
export * from "./UnbornReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports